import React from "react";
import { useMsal } from "@azure/msal-react";
import "./LoggedInCard.css";

const LoggedInCard = () => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <div className="loggedin-card">
      <span className="loggedin-name">{account?.name || "User"}</span>
      <button className="loggedin-logout" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

export default LoggedInCard;
